import { AxiosLMInstance, getAxiosInstance } from "../ApiConfig";

const getErrorMessage = (err) =>
    err?.response?.data?.message?.message || err?.response?.data?.message || err?.message || "Something went wrong";

async function GetCustomertypes() {
    try {
        const response = await AxiosLMInstance().get(`/customer-types`);
        return response.data
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function GetCustomertypeById(id) {
    try {
        const response = await AxiosLMInstance().get(`/customer-types/${id}`);
        return response.data
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function findEligibleForCustomerType(id) {
    try {
        const response = await AxiosLMInstance().get(`/plans/findEligibleForCustomerType/${id}`);
        return response.data
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function GetPlans() {
    try {
        const response = await AxiosLMInstance().get(`/plans`);
        return response.data
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function getPlanDetail(id) {
    try {
        const response = await AxiosLMInstance().get(`/plans/${id}`);
        return response.data
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function getCustomerSubcription(customerId) {
    try {
        const response = await AxiosLMInstance().get(`/subscriptions/customer/${customerId}`);
        return response.data
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function GetSubscriptionHistory(id) {
    try {
        const response = await AxiosLMInstance().get(`/subscriptions/${id}/history`);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function GetSubscriptionScheduledChanges(id) {
    try {
        const response = await AxiosLMInstance().get(`/subscriptions/${id}/scheduled-changes`);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function GetSubscriptionInvoices(id) {
    try {
        const response = await AxiosLMInstance().get(`/subscriptions/${id}/invoices`);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function DowngradeSubscription(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${payload.subscriptionId}/change/downgrade`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function CancelSubscription(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${payload.subscriptionId}/cancel`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function ReactivateSubscription(id, payload = {}) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${id}/reactivate`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function UpgradeSubscription(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/upgrade/preview`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function UpgradeSubscriptionConfirm(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/upgrade/confirm`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function UpgradeIntervalPreview(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/upgrade-interval/preview`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function UpgradeIntervalConfirm(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/upgrade-interval/confirm`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function ChangeSeatsPreview(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/change-seats/preview`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function ChangeSubscriptionToMonthly(id, payload = {}) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${id}/change/to-monthly`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function ChangeSubscriptionToAnnual(id, payload = {}) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${id}/change/to-annual`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function UpgradeFromTrial(id, payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${id}/upgrade-from-trial`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function SuspendSubscription(id, payload = {}) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${id}/suspend`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function ConfirmSeatChange(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/change-seats/confirm`, payload);
        return response;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function AssignSubscriptionSeat(id, payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${id}/seats/assign`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function CancelScheduledChange(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/cancel-scheduled-change`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function UpdateCustomAmount(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/update-custom-amount`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function SavePrimaryContact(payload) {
    try {
        const response = await AxiosLMInstance().post(`/primaryContact/savePrimaryContact`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function UpdatePrimaryContact(id, payload) {
    try {
        const response = await AxiosLMInstance().put(`/primaryContact/updatePrimaryContact/${id}`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function FindPrimaryAccountByCustomerId(id) {
    try {
        const response = await AxiosLMInstance().get(`/primaryContact/findPrimaryAccountByCustomerId/${id}`);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function FindPrimaryAccountById(id) {
    try {
        const response = await AxiosLMInstance().get(`/primaryContact/findPrimaryAccountById/${id}`);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function RevokeSubscriptionSeat(id, payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/${id}/seats/revoke`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function CreateSetupIntent(stripeCustomerId) {
    try {
        const response = await AxiosLMInstance().get(`/subscriptions/createSetupIntent/${stripeCustomerId}`);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function GetPaymentMethods(stripeCustomerId) {
    try {
        const response = await AxiosLMInstance().get(`/subscriptions/getPaymentMethods/${stripeCustomerId}`);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function RemovePaymentMethod(paymentMethodId) {
    try {
        const response = await AxiosLMInstance().get(`/subscriptions/removePaymentMethod/${paymentMethodId}`);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function getBlobErrorMessage(err) {
    let msg = getErrorMessage(err);
    const data = err?.response?.data;
    if (data instanceof Blob) {
        try {
            const parsed = JSON.parse(await data.text());
            msg = parsed?.message?.message || parsed?.message || msg;
        } catch (_) { /* keep default message */ }
    }
    return msg;
}
async function DownloadInvoiceReceipt(invoiceId) {
    try {
        const response = await AxiosLMInstance().get(
            `/subscriptions/receipt/${invoiceId}`,
            { responseType: "blob" }
        );
        return response;
    } catch (err) {
        throw await getBlobErrorMessage(err);
    }
}
async function DownloadInvoice(invoiceId) {
    try {
        const response = await AxiosLMInstance().get(
            `/subscriptions/invoice/${invoiceId}`,
            { responseType: "blob" }
        );
        return response;
    } catch (err) {
        throw await getBlobErrorMessage(err);
    }
}
async function CreateNewSubscription(payload) {
    try {
        const response = await AxiosLMInstance().post(`/subscriptions/createNewSubscription`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function AddAiTokens(companyCode, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/addAiTokens/crm_square_Cxsquare@481!/${companyCode}`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function licenceValidate(payload) {
    try {
        const response = await AxiosLMInstance().post(`/license/validate`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
async function licenceLogout(payload) {
    try {
        const response = await AxiosLMInstance().post(`/license/logout`, payload);
        return response.data;
    } catch (err) {
        throw getErrorMessage(err);
    }
}
export {
    SavePrimaryContact, UpdatePrimaryContact, FindPrimaryAccountByCustomerId, FindPrimaryAccountById, getCustomerSubcription, licenceValidate,
    GetCustomertypes, GetCustomertypeById, findEligibleForCustomerType, GetPlans, getPlanDetail, CancelSubscription, ReactivateSubscription,
    UpgradeSubscriptionConfirm, UpgradeSubscription, UpgradeIntervalPreview, UpgradeIntervalConfirm, ChangeSeatsPreview, licenceLogout,
    ChangeSubscriptionToMonthly, ChangeSubscriptionToAnnual, UpgradeFromTrial, SuspendSubscription, GetSubscriptionScheduledChanges,
    AssignSubscriptionSeat, RevokeSubscriptionSeat, CreateSetupIntent, GetPaymentMethods, RemovePaymentMethod, GetSubscriptionInvoices,
    CancelScheduledChange, UpdateCustomAmount, GetSubscriptionHistory, DowngradeSubscription, ConfirmSeatChange, DownloadInvoiceReceipt, DownloadInvoice,
    CreateNewSubscription, AddAiTokens
};